import React, { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { actions } from "./action.js";
function AsyncActionLocationTracker() {
  const dispatch = useDispatch();
  const location = useLocation();
  const prevLocation = useRef(location);
  useEffect(() => {
    prevLocation.current = location;
  }, []);
  useEffect(() => {
    const pathnameChanged = prevLocation.current.pathname !== location.pathname;
    prevLocation.current = location;
    if (pathnameChanged) {
      dispatch(actions.cancelRequests());
    }
  }, [location]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null);
}
export {
  AsyncActionLocationTracker
};
//# sourceMappingURL=AsyncActionLocationTracker.js.map
